module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-4.d9d4b78c.webp";